export const tableColumn = {
  service: "service",
  services: "services",
  surchargeType: "surchargeType",
  surchargeTypeAutocomplete: "surchargeTypeAutocomplete",
  organization: "organization",
  client: "client",
  team: "team",
  location: "location",
  locations: "locations",
  locationsWithIcon: "locationsWithIcon",
  rateLocations: "rateLocations",
  rates: "rates",
  parent: "parent",
  users: "users",
  group: "group",
  boolean: "boolean",
  date: "date",
  datetime: "datetime",
  download: "download",
  copy: "copy",
  loadLocation: "loadLocation",
  comment: "comment",
  editableComment: "editableComment",
  warning: "warning",
  debug: "debug",
  info: "info",
  link: "link",
  textLink: "textLink",
  quote: "quote",
  relatedQuote: "relatedQuote",
  quoteSource: "quoteSource",
  status: "status",
  timeAgo: "timeAgo",
  datePicker: "datePicker",
  direction: "direction",
  currency: "currency",
  container: "container",
  priceBox: "priceBox",
  percentBox: "percentBox",
  weightInTon: "weightInTon",
  disabled: "disabled",
  default: "default",
  number: "number",
  numberDisplayAlsoZero: "numberDisplayAlsoZero",
  opened: "opened",
  editable: "editable",
  country: "country",
  countries: "countries",
  loadType: "loadType",
  transportType: "transportType",
  unitType: "unitType",
  marginType: "marginType",
  password: "password",
};
